import D1StaticData from "@/pages/d1/D1StaticData/main";
import D1TimeSeries from "@/pages/d1/D1TimeSeries/main";
import D1Transactions from "@/pages/d1/D1Transactions/main";
import D1Events from "@/pages/d1/D1Events/main";
import { Route, Routes } from "react-router-dom";
import D1DownloadCenter from "./D1DownloadCenter/main";
import D1Issuers from "./D1Issuers/main";
import D1PdfPageSelection from "./D1PdfPageSelection/main";
import D1Portfolios from "./D1Portfolios/main";
import D1DataUpload from "./D1DataUpload/main";
import D1BankPositions from "./D1BankPositions/main";

export default function D1Routes() {
  return (
    <Routes>
      <Route path="d1_events/*" element={<D1Events />} />
      <Route path="d1_static_data/*" element={<D1StaticData />} />
      <Route path="d1_time_series/*" element={<D1TimeSeries />} />
      <Route path="d1_transactions/*" element={<D1Transactions />} />
      <Route path="d1_bank_positions/*" element={<D1BankPositions />} />
      <Route path="d1_portfolios/*" element={<D1Portfolios />} />
      <Route path="d1_issuers/*" element={<D1Issuers />} />
      <Route path="d1_pdf_page_selection/*" element={<D1PdfPageSelection />} />
      <Route path="d1_download_center/*" element={<D1DownloadCenter />} />
      <Route path="d1_data_upload/*" element={<D1DataUpload />} />
    </Routes>
  );
}
